// Zentrale SEO-Strategie für alle Service-Seiten
// Enthält hoch-intentionale Keyword-Cluster & Schema.org-Generatoren

// ─── Keyword-Cluster pro Service (Long-Tail + High-Intent) ───
export const keywordClusters = {
  privatumzug: {
    primary: 'Privatumzug Zürich',
    longTail: ['Privat umziehen Zürich', 'Umzugshelfer Zürich', 'Umzug privat Zürich', 'private Umzugsfirma Zürich', 'Zügelfirma Zürich privat'],
    semantic: ['Zügeln', 'Umziehen', 'Möbeltransport', 'Wohnungswechsel', 'Haushaltstransport'],
  },
  firmenumzug: {
    primary: 'Firmenumzug Zürich',
    longTail: ['Büroumzug Zürich', 'Geschäftsumzug Zürich', 'Büro zügeln Zürich', 'Büroumzug ohne Betriebsunterbruch', 'IT-Umzug Zürich'],
    semantic: ['Servertransport', 'Büromöbel', 'Geschäftsumzug', 'Firmenrelokation', 'Büroverlegung'],
  },
  seniorenumzug: {
    primary: 'Seniorenumzug Zürich',
    longTail: ['Senioren umziehen Zürich', 'Umzug ins Pflegeheim Zürich', 'Senioren Umzugshilfe Zürich', 'behutsamer Umzug Zürich', 'Wohnungsauflösung Senior'],
    semantic: ['Altersheim', 'Pflegeheim', 'Nachlass', 'Wohnungswechsel im Alter', 'Einrichtungs-Hilfe'],
  },
  reinigung: {
    primary: 'Endreinigung Zürich',
    longTail: ['Umzugsreinigung Zürich', 'Wohnungsreinigung Zürich', 'Reinigungsfirma Zürich', 'Endreinigung mit Abnahmegarantie', 'Kaution zurück Zürich'],
    semantic: ['Übergabereinigung', 'Auszugsreinigung', 'Wohnungsübergabe', 'Reinigungscheckliste', 'besenkehrrein'],
  },
  moebellift: {
    primary: 'Möbellift Zürich mieten',
    longTail: ['Aussenaufzug Zürich', 'Hebebühne Möbellift Zürich', 'Möbellift mieten Zürich', 'Aussenaufzug mieten Zürich', 'Möbellift für Altbau Zürich'],
    semantic: ['Hebebühne', 'Aussenaufzug', 'Möbeltransport', 'Stockwerklift', 'Fensterlift'],
  },
  lagerung: {
    primary: 'Möbellager Zürich',
    longTail: ['Möbel einlagern Zürich', 'Lagerraum Zürich mieten', 'Möbellagerung Zürich', 'Zwischenlager Zürich', 'Möbel deponieren Zürich'],
    semantic: ['Einlagerung', 'Lagerhalle', 'Selfstorage', 'Möbeldepot', 'Zwischenlagerung'],
  },
  entsorgung: {
    primary: 'Möbel entsorgen Zürich',
    longTail: ['Haushaltsauflösung Zürich', 'Sperrgut entsorgen Zürich', 'Möbelentsorgung Zürich', 'Elektroschrott entsorgen Zürich', 'Entsorgung mit Quittung'],
    semantic: ['Recycling', 'Deponie', 'Abfallentsorgung', 'Wertstoffhof', 'Sammelstelle'],
  },
  raeumung: {
    primary: 'Wohnungsauflösung Zürich',
    longTail: ['Nachlassräumung Zürich', 'Wohnung räumen Zürich', 'Hausräumung Zürich', 'Wohnungsauflösung mit Entsorgung', 'Todesfall Räumung Zürich'],
    semantic: ['Nachlass', 'Erbschaft', 'Zwangsräumung', 'Lagerräumung', 'Wohnungsleerung'],
  },
  'nationaler-umzug': {
    primary: 'Nationaler Umzug Schweiz',
    longTail: ['Fernumzug Schweiz', 'Umzug Schweiz weit', 'Langstrecken-Umzug Schweiz', 'Umzug in andere Kantone', 'Schweizweiter Umzug'],
    semantic: ['Langstrecke', 'Ferntransport', 'Kantonswechsel', 'Inlandsumzug', 'Schweiztransport'],
  },
  'umzug-europa': {
    primary: 'Auslandsumzug Zürich',
    longTail: ['Internationaler Umzug Zürich', 'Europa Umzug Schweiz', 'Umzug ins EU-Ausland', 'Auswanderung Umzug', 'Zollfreier Umzug Europa'],
    semantic: ['Zollabwicklung', 'EU-Umzug', 'Grenzüberschreitend', 'Auslandstransport', 'Europaumzug'],
  },
  'umzug-deutschland': {
    primary: 'Umzug Schweiz Deutschland',
    longTail: ['Umzug Zürich nach Deutschland', 'Zoll Umzug CH DE', 'Umzug nach München ab Zürich', 'Umzug nach Berlin Schweiz', 'Rückzug Deutschland Schweiz'],
    semantic: ['Grenzübertritt', 'Zollanmeldung', 'CH-DE Umzug', 'Deutschlandtransport', 'Auswanderung Deutschland'],
  },
};

// ─── Service-Schema.org Generator (MovingCompany) ───
export function getServiceSchema(service, seo) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: `Umzug City – ${service.breadcrumb}`,
    serviceType: service.breadcrumb,
    description: seo.description,
    url: seo.canonical,
    image: service.image,
    areaServed: {
      '@type': 'Country',
      name: 'Schweiz',
    },
    provider: {
      '@type': 'MovingCompany',
      name: 'Umzug City',
      telephone: '+41445143366',
      email: 'info@umzugcity.ch',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Pünten 4',
        postalCode: '8602',
        addressLocality: 'Wangen-Brüttisellen',
        addressCountry: 'CH',
      },
      areaServed: ['Zürich', 'Winterthur', 'Zug', 'Aargau', 'Thurgau', 'Schwyz', 'St. Gallen', 'Schaffhausen'],
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'CHF',
      availability: 'https://schema.org/InStock',
    },
  };
}

// ─── Breadcrumb-Schema Generator ───
export function getBreadcrumbSchema(service) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://umzugcity.ch/' },
      { '@type': 'ListItem', position: 2, name: service.breadcrumb, item: `https://umzugcity.ch/${service.slug}` },
    ],
  };
}

// ─── FAQ-Schema Generator (aus FAQ-Array) ───
export function getFaqPageSchema(faqs) {
  if (!faqs || faqs.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(f => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
}

// ─── Kombiniertes Schema für Service-Seiten ───
export function getCombinedServiceSchema(service, seo) {
  const schemas = [getServiceSchema(service, seo), getBreadcrumbSchema(service)];
  const faqSchema = getFaqPageSchema(service.faqs);
  if (faqSchema) schemas.push(faqSchema);
  return schemas.length === 1 ? schemas[0] : { '@graph': schemas };
}